module.exports = __webpack_public_path__ + "static/media/ic_video_minimize.52fe11dc.svg";